/**
 * Lee y cachea el token CSRF.
 *
 * Convención: el backend lo expone vía GET /api/me (campo `csrf_token`).
 * Se invalida cuando recibimos 401 o cuando se hace logout.
 */

let cached: string | null = null;
let inflight: Promise<string | null> | null = null;

interface MeWithCsrf {
  csrf_token?: string;
}

export async function getCsrfToken(): Promise<string | null> {
  if (cached) return cached;
  if (inflight) return inflight;

  inflight = fetch('/api/me/', { credentials: 'include' })
    .then(async (res) => {
      if (!res.ok) return null;
      const data = (await res.json()) as MeWithCsrf;
      cached = data.csrf_token ?? null;
      return cached;
    })
    .catch(() => null)
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

export function invalidateCsrf(): void {
  cached = null;
}
